import { Text } from '@applane/react-core-components';
import React from 'react';
import { Form } from '../../../app-components/form/Form';
import { viewUri } from '../../../Queries/subscriptionHistory';

export const ShowHistoryItem = (props) => {
  return (
    <Form
      type="standard"
      uri={viewUri}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groups: [
              {
                columns: [
                  {
                    type: 'text',
                    field: 'purchasedByName',
                    label: 'Purchased By',
                    editable: false,
                  },
                  {
                    type: 'text',
                    field: 'dealerId.username',
                    label: 'Purchased For',
                    editable: false,
                  },
                  {
                    type: 'date',
                    field: 'transactionDateTime',
                    label: 'Date Generated',
                    editable: false,
                  },
                  {
                    render: ({ data }) => (
                      <Text style={{ fontSize: 17 }}>
                        {data.transactionMode !== 'CASH' ? data._id : 'N.A'}
                      </Text>
                    ),
                    label: 'Transaction Id',
                    editable: false,
                  },
                  {
                    label: 'Price',
                    render: ({ data }) => (
                      <Text style={{ fontSize: 17 }}>$ {data.price}</Text>
                    ),
                  },
                  {
                    type: 'text',
                    field: 'transactionMode',
                    label: 'Payment Mode',
                    editable: false,
                  },
                ],
              },
            ],
          },
        ],
      }}
      {...props}
    />
  );
};
